import * as React from 'react';
import { Route } from 'react-router-dom';
// import Configuration from './configuration/Configuration';
import ConversationsList from './chat/ConversationsList';
export default [
    // <Route exact path="/configuration" render={() => <Configuration />} />,
    <Route exact path="/conversations" render={() => <ConversationsList />} />,
    // <Route exact path="/conversations/one/:id" component={OneConversation} />,
];
